import React from "react";
import { CUSTOMISATION_OPTIONS } from "../../constants/all-customisation-options";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditing,
  selectFinishedEditing,
  updateEditState,
} from "../../customisation-slice";
import NavigationButton from "./navigation-button";

const Navigation = () => {
  const dispatch = useDispatch();
  const editingKey = useSelector(selectEditing);
  const finishedEditing = useSelector(selectFinishedEditing);
  const customisationOptionsKeys = Object.keys(CUSTOMISATION_OPTIONS);
  const totalSteps = customisationOptionsKeys.length;
  const currentStep = customisationOptionsKeys.findIndex(
    (key) => key === editingKey
  );
  const previousStep =
    currentStep !== 0 ? customisationOptionsKeys[currentStep - 1] : null;
  const nextStep =
    currentStep !== totalSteps
      ? customisationOptionsKeys[currentStep + 1]
      : null;

  const changeStep = (newStep) => {
    dispatch(updateEditState(newStep));
  };

  return (
    <div className="min-h-55 md:min-h-110 border-b border-light-grey flex items-center justify-center relative">
      <div className="absolute flex flex-col justify-center items-center">
        <div className="heading-2">
          {CUSTOMISATION_OPTIONS[editingKey].title}
        </div>
        <div className="hidden md:block navigation-text mt-2">{`${
          currentStep + 1
        }/${totalSteps}`}</div>
      </div>
      {previousStep && !finishedEditing && (
        <NavigationButton
          side="left"
          label={CUSTOMISATION_OPTIONS[previousStep].title}
          onClick={() => changeStep(previousStep)}
        />
      )}
      {nextStep && !finishedEditing && (
        <NavigationButton
          label={CUSTOMISATION_OPTIONS[nextStep].title}
          onClick={() => changeStep(nextStep)}
        />
      )}
    </div>
  );
};

export default Navigation;
